export enum RangeSliderUnit {
    Years = 'years',
    Euro = 'euro',
}
